const likertOptions = [
  { label: 'Strongly Disagree', value: 1 },
  { label: 'Disagree', value: 2 },
  { label: 'Neither Agree nor Disagree', value: 3 },
  { label: 'Agree', value: 4 },
  { label: 'Strongly Agree', value: 5 },
];

export const page1Questions = [
  {
    key: 'talkRegularly',
    label: 'I regularly stop and talk with people in my neighborhood.',
    type: 'likert',
    options: likertOptions,
  },
  {
    key: 'civicGroups',
    label: 'I take part in some social or civic groups in my neighborhood.',
    type: 'likert',
    options: likertOptions,
  },
  {
    key: 'attendReligious',
    label: 'I attend religious services in my neighborhood.',
    type: 'radio',
    options: ['Yes', 'No', 'In another neighborhood'],
  },
    {
    key: 'knownNeighbors',
    label: 'Approximately how many neighbors would you say you know personally, at least as acquaintances?',
    type: 'slider',
    min: 0,
    max: 500,
  },
  {
    key: 'friendNeighbors',
    label: 'Of your neighborhood acquaintances, about how many of these would you consider to be friends?',
    type: 'slider',
    min: 0,
    max: 500,
  },
  {
    key: 'wishMoreContact',
    label: 'I wish I had more contact with people in my neighborhood.',
    type: 'likert',
    options: likertOptions,
  },
  {
    key: 'senseOfCommunity',
    label: 'Living in this neighborhood gives me a sense of community.',
    type: 'likert',
    options: likertOptions,
  },
  {
    key: 'belonging',
    label: 'I feel like I belong in my neighborhood.',
    type: 'likert',
    options: likertOptions,
  },
  {
    key: 'identity',
    label: 'Being of this neighborhood is an important part of who I am.',
    type: 'likert',
    options: likertOptions,
  },
  {
    key: 'empathy',
    label: 'I am motivated to understand the thoughts and feelings of people who are my neighbors.',
    type: 'likert',
    options: likertOptions,
  },
 // {
 //   key: 'conflictHarmony',
 //   label: 'Generally, how much do you perceive relations in your neighborhood to be in conflict or in harmony?',
 //   type: 'rank',
 //   min: 1,
 //   max: 5,
 //   leftLabel: 'Conflict',
 //   rightLabel: 'Harmony'
 // },
  {
    key: 'acceptanceRace',
    label: 'People in my neighborhood are willing to accept people from different racial and ethnic groups as neighbors.',
    type: 'likert',
    options: likertOptions,
  },
   {
    key: 'acceptancePolitics',
    label: 'People in my neighborhood are willing to accept people with different political viewpoints as neighbors',
    type: 'likert',
    options: likertOptions,
  },
   {
    key: 'acceptanceClass',
    label: 'People in my neighborhood are willing to accept people with different income levels as neighbors',
    type: 'likert',
    options: likertOptions,
  },
  {
    key: 'satisfaction',
    label: 'Taking everything into account, I am satisfied with this neighborhood as a place to live?',
    type: 'likert',
    options: likertOptions,
  },
  {
    key: 'planToStay',
    label: 'I plan to remain a resident of this neighborhood for a number of years.',
    type: 'likert',
    options: likertOptions,
  },
  {
    key: 'trust',
    label: 'People in my neighborhood can be trusted.',
    type: 'likert',
    options: likertOptions,
  },
  {
    key: 'awareOfEvents',
    label: 'If something happens that affects my neighborhood, I usually find out about it right away.',
    type: 'likert',
    options: likertOptions,
  },
  {
    key: 'helpfulNeighbors',
    label: 'People around here are willing to help their neighbors.',
    type: 'likert',
    options: likertOptions,
  },
  {
    key: 'problemSolving',
    label: 'If there is a problem around here, the neighbors get together to deal with it.',
    type: 'likert',
    options: likertOptions,
  },
  {
    key: 'willingToImprove',
    label: 'I would be willing to work together with others on something to improve my neighborhood.',
    type: 'likert',
    options: likertOptions,
  },
];
export const page2Questions = [
  {
    key: 'gender',
    label: 'What is your gender?',
    type: 'dropdown',
    options: [
      'Male',
      'Female',
      'Non-binary',
      'Prefer not to say',
    ],
  },
  {
    key: 'raceEthnicity',
    label: 'What race or ethnicity best describes you?',
    type: 'dropdown',
    options: [
      'Black or African American',
      'Hispanic or Latino',
      'Asian',
      'Native American or Alaska Native',
      'Middle Eastern or North African',
      'Native Hawaiian or Other Pacific Islander',
      'Multiracial',
      'White',
      'Other',
      'Prefer not to say',
    ],
  },
  {
    key: 'age',
    label: 'What is your age?',
    type: 'dropdown',
    options: [
      'Under 18',
      '18–24',
      '25–34',
      '35–44',
      '45–54',
      '55–64',
      '65–74',
      '75+',
      'Prefer not to say',
    ],
  },
  {
    key: 'married',
    label: 'Are you currently married and living with your spouse?',
    type: 'radio',
    options: ['Yes', 'No'],
  },
  {
    key: 'householdSize',
    label: 'Including yourself, how many people live in your household?',
    type: 'slider',
    min: 1,
    max: 20,
  },
  {
    key: 'childrenUnder18',
    label: 'How many children under 18 live in your household?',
    type: 'slider',
    min: 0,
    max: 20,
  },
  {
    key: 'income',
    label: 'Approximate household income',
    type: 'dropdown',
    options: [
      'Under $25,000',
      '$25,000–$49,999',
      '$50,000–$74,999',
      '$75,000–$99,999',
      '$100,000–$149,999',
      '$150,000–$199,999',
      '$200,000-$500,000',
      '$500,000 or more',
      'Prefer not to say',
    ],
  },
  {
    key: 'housingStatus',
    label: 'Do you or your family rent or own your current home?',
    type: 'radio',
    options: ['Rent', 'Own'],
  },
  {
    key: 'grewUpHere',
    label: 'Did you grow up in this neighborhood?',
    type: 'radio',
    options: ['Yes', 'No'],
  },
];